import { Comments } from "features/campaign/presentation/components/campaignDetails/commentsComponent";
import { CommentsResponse } from "features/campaign/domain/models/comments";

const CommentsComponent = ({ data }: { data: CommentsResponse[] }) => {
    return <ul id="comments-section" className="mt-4">
        <span className="text-body-lg font-bold text-black">Comments</span>

        {data && data.length > 0 ? (
            data.map((comment, index) => (
                <Comments
                    full_name={comment.full_name}
                    text={comment.text}
                    key={index}
                    createdAt={comment.createdAt}
                />
            ))
        ) : (
            <p className="mt-4 text-center text-body-lg text-sub-600">
                No Comments yet
            </p>
        )}
    </ul>;
};

export default CommentsComponent;